module.exports = __webpack_public_path__ + "img/it.e9ee0f62.svg";